var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 27c-6-5-13-7-20-7-13 0-25 8-29 20L5 27C14 11 32 0 51 0c13 0 25 4 34 13L71 27Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59c-2-6-2-13 0-19L5 27c-7 14-7 31 0 45 9 16 27 27 46 27 14 0 25-4 34-12 9-9 15-21 15-36l-1-10H51v19h28c-2 6-5 11-11 15-4 3-10 4-17 4-13 0-25-8-29-20L5 72l17-13Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleButton);
export default __webpack_public_path__ + "static/media/google-button.564aa780b31d05ce000cf8a0d95f55ac.svg";
export { ForwardRef as ReactComponent };